import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import WodaOdczytyRazemSzczegolyWm from "./WodaOdczytyRazemSzczegolyWm";
import WodaOdczytyRazemSzczegolyWm2 from "./WodaOdczytyRazemSzczegolyWm2";
import WodaOdczytyRazemSzczegolyWm3 from "./WodaOdczytyRazemSzczegolyWm3";

const WodaOdczytyRazemSzczegoly = props => {

    const { wybraneRozliczenie, setEdit, edytowanyZakres, wybranyZakres, czyWmSavedAkt } = props;
    // console.log(wybraneRozliczenie)
    return (
        <div className="woda-odczyty-szczegoly">
            <ul>
                <li className="ramka">
                    <div className='naglowek'>                                    
                        <p className="opis tytul">
                            { `Opis: ${wybranyZakres && wybraneRozliczenie?.opis || ''}`}
                        </p>
                         { edytowanyZakres && (<FontAwesomeIcon 
                            icon={faPencil} 
                            onClick={()=>setEdit( prevState => !prevState)}    
                            className="pointer"
                        />)}
                    </div>
                    {
                        wybranyZakres && (
                            <div className='odczyt-szczegoly'>

                                <div className='szczegoly-odczyty'>
                                    <WodaOdczytyRazemSzczegolyWm
                                        wybraneRozliczenie={wybraneRozliczenie} 
                                    />
                                    <WodaOdczytyRazemSzczegolyWm2
                                        wybraneRozliczenie={wybraneRozliczenie}
                                    />
                                    <WodaOdczytyRazemSzczegolyWm3
                                        wybraneRozliczenie={wybraneRozliczenie}
                                        czyWmSavedAkt={czyWmSavedAkt}
                                    />
                                </div>
                            </div>
                        )
                    }
                </li>
            </ul>
        </div>
    )
}

export default WodaOdczytyRazemSzczegoly;